import { render, staticRenderFns } from "./PhoneWidget.vue?vue&type=template&id=7f4778ee&scoped=true"
import script from "./PhoneWidget.vue?vue&type=script&lang=js"
export * from "./PhoneWidget.vue?vue&type=script&lang=js"
import style0 from "./PhoneWidget.vue?vue&type=style&index=0&id=7f4778ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4778ee",
  null
  
)

export default component.exports